// extracted by mini-css-extract-plugin
export default {"payment-methods":"HDhFe","payment-methods-button":"VgbEz","payment-methods-button--selected":"kKLOi","skeleton-button":"M21ji"};